module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nb-root"
  }, [(_vm.showLanguage) ? _c('div', {
    staticClass: "nb-lang"
  }, [_vm._v(_vm._s(_vm.message.language))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nb-chat"
  }, [_c('div', {
    staticClass: "nb-bubble"
  }, [(_vm.message.headerMedia) ? _c('media-preview', {
    attrs: {
      "format": _vm.message.headerMedia.format,
      "media-id": _vm.message.headerMedia.mediaId,
      "media-name": _vm.message.headerMedia.mediaName || '',
      "file-name": _vm.message.headerMedia.fileName || '',
      "country-id": _vm.message.headerMedia.countryId,
      "language-id": _vm.message.headerMedia.languageId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message.header) ? _c('div', {
    staticClass: "nb-header"
  }, [_vm._v(_vm._s(_vm.message.header))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nb-body"
  }, [_vm._v(_vm._s(_vm.message.body || 'No message text saved for this language.'))]), _vm._v(" "), (_vm.message.footer) ? _c('div', {
    staticClass: "nb-footer"
  }, [_vm._v(_vm._s(_vm.message.footer))]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.message.buttons), function(b) {
    return _c('div', {
      key: b,
      staticClass: "nb-button"
    }, [_vm._v(_vm._s(b))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "nb-src"
  }, [_vm._v("\n    " + _vm._s(_vm.message.source === 'template' ? ("Approved template: " + (_vm.message.templateName)) : 'Saved message text, no approved template attached') + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6bb1c7ac","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/analytics/NudgeBubble.vue
// module id = Z27D
// module chunks = 1